module.exports = __webpack_public_path__ + "img/error.ce70de87.png";